import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_EDIT_FIELD_BEGIN,
  COLLECTIONS_EDIT_FIELD_SUCCESS,
  COLLECTIONS_EDIT_FIELD_FAILURE,
  COLLECTIONS_EDIT_FIELD_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function editField(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_EDIT_FIELD_BEGIN,
    });
    const { projectId, collectionName, data, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collectionName}/fields/${data._id}`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_EDIT_FIELD_SUCCESS,
              data: res.data,
              collectionName,
            });
            Mixpanel.track('Updated collection field', { collectionName });
            toast.success('Updated Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_EDIT_FIELD_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to update collection field');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation Failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_EDIT_FIELD_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update collection field');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissEditFieldError() {
  return {
    type: COLLECTIONS_EDIT_FIELD_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_EDIT_FIELD_BEGIN:
      return {
        ...state,
        editFieldPending: true,
        editFieldError: null,
      };

    case COLLECTIONS_EDIT_FIELD_SUCCESS:
      let currentFields = state.selectedCollection.fields || [];
      let index = currentFields.findIndex(function (item, i) {
        return item._id === action.data._id;
      });
      currentFields[index] = action.data;

      let projectCollections = state.projectCollections;
      let collectionIndex = projectCollections.findIndex((item) => {
        return item.collectionName === action.collectionName;
      });
      projectCollections[collectionIndex].fields = currentFields;
      return {
        ...state,
        editFieldPending: false,
        editFieldError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          fields: currentFields,
        },
      };

    case COLLECTIONS_EDIT_FIELD_FAILURE:
      return {
        ...state,
        editFieldPending: false,
        editFieldError: action.data.error,
      };

    case COLLECTIONS_EDIT_FIELD_DISMISS_ERROR:
      return {
        ...state,
        editFieldError: null,
      };

    default:
      return state;
  }
}
